export const MIN_SALARY = 0;
export const MAX_SALARY = 10000;
